import angular from "angular";

let mod = angular
    .module('scheduleGenerate.component', [])
    .component('scheduleGenerate', {
        template: require('./schedule-generate.component.html'),
        controller: ['Upload', '$http', '$q', controller],
        bindings: {
            routes: '<',
        }
    });

function controller(Upload, $http, $q) {

    let $ctrl = this;

    $ctrl.file = null;

    $ctrl.$onInit = function () {
    };

    $ctrl.upload = function () {
        $ctrl.uploadLoading = true;
        Upload
            .upload({
                url: '/schedule-generate/parse-excel',
                data: {file: $ctrl.file},
            })
            .then(
                function (response) {
                    $ctrl.uploadLoading = false;
                    $ctrl.routes = response.data.routes;
                },
                function (error) {
                    $ctrl.uploadLoading = false;
                }
            );
    };

    $ctrl.startGenerate = function () {

        $ctrl.loading = true;

        $ctrl.routes.forEach(function (route) {
            route.status = 'waiting';
        });

        loadRouteSchedule(0);
    };

    function loadRouteSchedule(ind) {

        let route = $ctrl.routes[ind];

        route.status = 'loading';

        loadPart(route, 1).then(
            function () {
                loadPart(route, 2).then(
                    function () {
                        loadPart(route, 3).then(
                            function () {
                                success();
                            },
                            function () {
                                failed();
                            }
                        );
                    },
                    function () {
                        failed();
                    },
                );
            },
            function () {
                failed();
            }
        );

        function success() {
            route.status = 'success';
            next();
        }

        function failed() {
            route.status = 'failed';
            next();
        }

        function next() {
            if (ind + 1 < $ctrl.routes.length) {
                loadRouteSchedule(ind + 1);
            } else {
                $ctrl.loading = false;
            }
        }
    }

    function loadPart(route, number) {
        return $http.get('/schedule-generate/load-schedule', {
            params: {
                dep_station_code: route.dep_station_code,
                dep_station_name: route.dep_station_name,
                arr_station_code: route.arr_station_code,
                arr_station_name: route.arr_station_name,
                number: number
            }
        });
    }

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/schedule-generate/schedule-generate.component.js